import {MetricConfiguration} from "areas/metrics/components/MetricSelector/types";
import {getUnitOrConversion} from "areas/metrics/components/MetricSelector/utils/getUnitOrConversion";
import {MetricPayload} from "areas/management/api";

export function convertMetricConfigurationToPayload(configuration: MetricConfiguration): MetricPayload {
	return {
		metricId: configuration.metricId,
		...getUnitOrConversion(configuration)
	}
}

export function convertMetricConfigurationsToPayload(configurations: MetricConfiguration[]){
	return configurations.map(convertMetricConfigurationToPayload)
}
